import OfertaList from './OfertaList.vue'

export default OfertaList

